import { Box, Stack } from '@mui/material';
import { Divider, Subheadline } from '@telegram-apps/telegram-ui';
import { ListCategory, ListGoal } from '../../../client/types';
import { CircularProgressWithIcon } from '../../common/CircularProgressWithIcon';

export type GoalDisplayProps = {
    goal: ListGoal;
    categoryMap: Record<string, ListCategory>;
    progress: number;
    xp: number;
    target: number;
    scale?: number;
};

export const GoalDisplay = ({ goal, categoryMap, progress, xp, target, scale = 1 }: GoalDisplayProps) => {
    const goalCategory = goal.categoryId in categoryMap ? categoryMap[goal.categoryId] : null;
    if (!goalCategory) return null;
    return (
        <Box sx={{ display: 'inline-block', transform: `scale(${scale})`, transformOrigin: 'center center' }}>
            <Stack direction="row" alignItems="center" gap={0.5}>
                <CircularProgressWithIcon icon={goalCategory.icon} progress={progress} />
                <Stack alignItems="center">
                    <Subheadline weight="3" style={{ fontSize: '10px', lineHeight: '10px' }}>
                        {Math.round(xp)}
                    </Subheadline>
                    <Divider style={{ width: '100%', margin: '4px 0px' }} />
                    <Subheadline weight="3" style={{ fontSize: '10px', lineHeight: '10px' }}>
                        {target}
                    </Subheadline>
                </Stack>
            </Stack>
        </Box>
    );
}; 